export default "__VITE_ASSET__977e3930__"